import { render } from "./DowntimesPage.vue?vue&type=template&id=10636b23&scoped=true"
import script from "./DowntimesPage.vue?vue&type=script&lang=js"
export * from "./DowntimesPage.vue?vue&type=script&lang=js"

import "./DowntimesPage.vue?vue&type=style&index=0&id=10636b23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10636b23"]])

export default __exports__